import styled from "styled-components"

export interface StyledProfileCardProps {
  wrapper_link?: boolean
}

export const StyledCardProfile = styled.div<StyledProfileCardProps>`
  background: white;
  border-radius: 4px;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.05);
  padding: 16px;
  border: 2px solid rgba(0, 0, 0, 0);

  display: flex;
  align-items: center;
  position: relative;
  ${(props) => props.theme.mixins.hoverTransition};

  ${(props) =>
    props.wrapper_link &&
    `
      pointer: cursor;
      &:hover {
        ${props.theme.mixins.hover};
    `}
`

export const StyledProfileImage = styled.div`
  width: 64px;
  height: 64px;
  background: black;
  border-radius: 32px;
  overflow: hidden;
  margin-right: 16px;
  background: white;
  & img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`

export const StyledCardProfileText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;

  & p {
    margin: 0;
  }

  & p:first-of-type {
    color: ${(props) => props.theme.colors.black};
  }
`

export const StyledCardLinkWrapper = styled.div``

export const StyledCardLink = styled.div`
  width: 100%;
  height: 100%;
  z-index: 10;
  position: absolute;
  top: 0;
  left: 0;
  & a {
    width: 100%;
    height: 100%;
    cursor: pointer;
    position: absolute;
    top: 0;
    left: 0;
    color: transparent;
  }
`
